import { render, staticRenderFns } from "./public-profile.vue?vue&type=template&id=59fac114&"
import script from "./public-profile.vue?vue&type=script&lang=js&"
export * from "./public-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports